export const debounce = function(fn: (...params: any[]) => any, time: any) {
  let timer: any;
  return (...args: any[]) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      fn.apply(null, [...args]);
    }, time);
  };
};
